export type ApiErrorPayload = {
  error?: string | { code?: string; displayMessage?: string };
  message?: string;
  detail?: string;
  action?: string;
  referenceId?: string;
};

function asApiErrorPayload(payload: unknown): ApiErrorPayload | null {
  return payload && typeof payload === "object" && !Array.isArray(payload) ? payload as ApiErrorPayload : null;
}

export function apiErrorCode(input: unknown, fallback = "REQUEST_FAILED") {
  const payload = asApiErrorPayload(input);
  if (typeof payload?.error === "string") return payload.error;
  return payload?.error?.code || fallback;
}

/** Preserves the server's operation/effect/recovery contract at every UI boundary. */
export function apiErrorMessage(input: unknown, status: number, fallback: string) {
  const payload = asApiErrorPayload(input);
  const displayMessage = typeof payload?.error === "object" ? payload.error.displayMessage : undefined;
  const parts = [
    payload?.message || displayMessage,
    payload?.detail,
    payload?.action,
    payload?.referenceId ? `Reference: ${payload.referenceId}` : undefined,
  ].filter((value): value is string => Boolean(value?.trim()));
  if (parts.length > 0) return parts.join(" ");
  const code = apiErrorCode(payload, "");
  if (code) return `${fallback} Error code: ${code}. HTTP ${status}.`;
  return `${fallback} The server returned HTTP ${status} without a readable error response. Retry once, then contact PRVBUY support if it continues.`;
}
